module.exports = __webpack_public_path__ + "media/v2/phone-v2-4d9d0964.svg";